import { formatNestedAttributeKey } from '@shared/workflow/formatNestedAttributeKey.js';

const getSelectedArgDetails = (key, values, steps) => {
  const argValue = values?.[key];
  const argStepId = argValue?.stepId;
  const argAttributeKey = argValue?.attributeKey;
  const argStep = steps?.find((n) => n.value === argStepId && !n.isArrayMap);
  const argAttribute = argStep?.attributes?.find((n) => n.key === argAttributeKey);
  const isFromMap = argValue?.parentKey;

  return {
    icon: argStep?.icon,
    label: argAttributeKey === 'input' || argAttributeKey === 'response' ? `${argStep?.name}` : `${formatNestedAttributeKey(argAttribute?.key)}`,
    number: argStep?.stepNumber,
    map: isFromMap
  };
};

export default getSelectedArgDetails;
